export default __webpack_public_path__ + "static/media/firebase.e12c5975.svg";